import Blue from "~/core";

new Blue({
  name: "site modals",
  selector: ".site-modals__modal--cookies",
  setup(cookies) {
    const closeBtn = cookies.querySelector(".site-modals__modal-close");
    const accept = cookies.querySelector(".site-modals__modal-accept");
    const decline = cookies.querySelector(".site-modals__modal-decline");
    const storage = window.localStorage;

    const checkForResponse = () => {
      return storage.getItem("acceptedCookies") || false;
    };

    const closeCookies = () => {
      cookies.classList.remove("site-modals__modal--active");
      setTimeout(() => {
        cookies.classList.add("site-modals__modal--dismissed");
      }, 350)
    };

    const openCookies = () => {
      setTimeout(() => {
        cookies.classList.add("site-modals__modal--active");
        closeBtn.setAttribute("tabindex", 1);
        accept.setAttribute("tabindex", 1);
        decline.setAttribute("tabindex", 1);
        closeBtn.focus();
      }, 750);
    }

    const setCookies = consent => {
      storage.setItem("acceptedCookies", consent);
      // DO STUFF HERE
      closeCookies();
    };


    if (!checkForResponse()) openCookies();

    this.$addEvents(closeBtn, "click enter", closeCookies);
    this.$addEvents(decline, "click enter", () => {
      setCookies(false);
    });
    this.$addEvents(accept, "click enter", () => {
      setCookies(true);
    });
  }
});
